import React, { Component } from 'react'
import GenericHeader from '../../GenericHeader'
import { connect } from 'react-redux'

const mapStateToProps = state => {
  return {
    accountBalance: state.bankSimulator.accountBalance,
  }
}
@connect(mapStateToProps)
class Header extends Component {
  render() {
    return (
      <GenericHeader height="180px">
        <div className="row" style={{ marginTop: '20px', marginLeft: '5px' }}>
          <div className="col-md-6">
            <div>
              <strong>CURRENT ACCOUNT </strong>
            </div>
            <div style={{ marginTop: '-5px' }}>0003323333</div>
          </div>
        </div>

        <div className="row">
          <div className="col" style={{ marginRight: '10px' }}>
            <div className="float-right">Account Balance</div>
          </div>
        </div>

        <div className="row">
          <div className="col" style={{ marginRight: '10px' }}>
            <div className="float-right">
              <h3>₦{this.props.accountBalance}</h3>
            </div>
          </div>
        </div>
      </GenericHeader>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/modules/Simulator/MainApp/InternetBankingSimulatorApp/screens/BalanceScreen/Header/index.js